exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-flexbox {\n  width: 100%;\n  text-align: left;\n  display: flex;\n  display: -webkit-flex;\n  box-align: center;\n  align-items: center;\n}\n.vux-flexbox .vux-flexbox-item {\n  flex: 1;\n  -webkit-flex: 1;\n  min-width: 20px;\n  width: 0%;\n}\n.vux-flexbox .vux-flexbox-item:first-child {\n  margin-left: 0!important;\n  margin-top: 0!important;\n}\n.vux-flex-row {\n  box-direction: row;\n  box-orient: horizontal;\n  flex-direction: row;\n}\n.vux-flex-col {\n  box-orient: vertical;\n  flex-direction: column;\n}\n.vux-flex-col > .vux-flexbox-item {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05455d6a","scoped":false,"hasInlineConfig":false}!./~/vux-loader/src/after-less-loader.js!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vux/src/components/flexbox/flexbox.vue
// module id = 253
// module chunks = 1